import script from "./UpdateInvoiceTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateInvoiceTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateInvoiceTemplateModal.vue?vue&type=style&index=0&id=15a2485b&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a2485b"]])

export default __exports__